import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { APP } from "@/constants/testIds";

export function FullscreenLoader() {
  return (
    <div
      data-testid={APP.loader}
      className="flex min-h-screen items-center justify-center bg-brand-bg"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-line border-t-brand-accent" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) return <FullscreenLoader />;
  if (!user)
    return (
      <Navigate
        to={`/logowanie?returnTo=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  return children;
}
